import React, { lazy, Suspense } from "react";
import ContentAreaLoadingFallback from "../components/common/ContentAreaLoadingFallback";

export function PageSuspense({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<ContentAreaLoadingFallback />}>{children}</Suspense>;
}

export const TaxManagementAlerts = lazy(() => import("../TaxManagementAlerts"));
export const Businesses = lazy(() => import("../components/Business/Businesses"));
export const BusinessDetail = lazy(() => import("../components/Business/BusinessDetail"));
export const RoleBasedAccess = lazy(() => import("../RoleBasedAccess"));
export const SignUpPage = lazy(() => import("../components/auth/SignUp/SignUpPage"));
export const VerificationCodePage = lazy(
  () => import("../components/auth/VerificationCode/VerificationCodePage")
);
export const CreatePasswordPage = lazy(
  () => import("../components/auth/CreatePassword/CreatePasswordPage")
);
export const BusinessLinkCodePage = lazy(
  () => import("../components/auth/BusinessLinkCode/BusinessLinkCodePage")
);
export const TrpsPaymentInfo = lazy(() => import("../TaxManagementPayment/TrpsPaymentInfo"));
export const ClientsPaymentInfo = lazy(() => import("../TaxManagementPayment/ClientsPaymentInfo"));
export const PaymentPage = lazy(() => import("../TaxManagementPayment/PaymentPage"));
export const AlertConfiguration = lazy(() => import("../TaxManagementAlerts/AlertConfiguration"));
export const UpdatePermissions = lazy(() => import("../UpdatePermissions"));
export const EditClientSelf = lazy(() => import("../TaxManagementClient/EditClientSelf"));
export const TermsAndConditions = lazy(() => import("../components/Business/TermsAndConditions"));
export const BusinessFeedback = lazy(() => import("../components/Business/Feedback"));
export const BusinessNotification = lazy(() => import("../components/Business/Notification"));
export const BusinessCategoryTemplates = lazy(
  () => import("../components/Business/CategoryTemplates")
);
export const SamaiHomePage = lazy(() => import("../Samai"));

export const ChatPage = lazy(() =>
  import("../components/MainContent/pages/Chat").then((m) => ({ default: m.default }))
);
export const Cases = lazy(() =>
  import("../components/MainContent/pages/Cases").then((m) => ({ default: m.default }))
);
export const CaseDetail = lazy(() =>
  import("../components/MainContent/pages/Cases/CaseDetail").then((m) => ({ default: m.default }))
);
export const CategoryDetail = lazy(() =>
  import("../components/MainContent/pages/Categories/CategoryDetail").then((m) => ({
    default: m.default,
  }))
);
export const SubCategoryDetail = lazy(() =>
  import("../components/MainContent/pages/Categories/SubCategoryDetail").then((m) => ({
    default: m.default,
  }))
);
export const ServiceDetail = lazy(() =>
  import("../components/MainContent/pages/Categories/ServiceDetail").then((m) => ({
    default: m.default,
  }))
);

export const Roles = lazy(() =>
  import("../components/MainContent/pages/Roles").then((m) => ({ default: m.default }))
);
export const Users = lazy(() =>
  import("../components/MainContent/pages/Users").then((m) => ({ default: m.default }))
);
export const Tags = lazy(() =>
  import("../components/MainContent/pages/Tags").then((m) => ({ default: m.default }))
);
export const Clients = lazy(() =>
  import("../components/MainContent/pages/Clients").then((m) => ({ default: m.default }))
);
export const ClientDetail = lazy(() =>
  import("../components/MainContent/pages/Clients/ClientDetail").then((m) => ({
    default: m.default,
  }))
);
export const BulkImport = lazy(() =>
  import("../components/MainContent/pages/Clients/BulkImport").then((m) => ({ default: m.default }))
);
export const Feedback = lazy(() =>
  import("../components/MainContent/pages/Feedback").then((m) => ({ default: m.default }))
);
export const FeedbackDetail = lazy(() =>
  import("../components/MainContent/pages/Feedback/FeedbackDetail").then((m) => ({
    default: m.default,
  }))
);
export const NoticeBoard = lazy(() =>
  import("../components/MainContent/pages/NoticeBoard").then((m) => ({ default: m.default }))
);
export const Downloads = lazy(() =>
  import("../components/MainContent/pages/Downloads").then((m) => ({ default: m.default }))
);
export const Reports = lazy(() =>
  import("../components/MainContent/pages/Reports").then((m) => ({ default: m.default }))
);
export const Categories = lazy(() =>
  import("../components/MainContent/pages/Categories").then((m) => ({ default: m.default }))
);
export const MyProfile = lazy(() =>
  import("../components/MainContent/pages/MyProfile").then((m) => ({ default: m.default }))
);
export const UserDetail = lazy(() =>
  import("../components/MainContent/pages/UserDetail").then((m) => ({ default: m.default }))
);
export const Dashboard = lazy(() =>
  import("../components/MainContent/pages/Dashboard").then((m) => ({ default: m.default }))
);
export const SearchResult = lazy(() =>
  import("../components/MainContent/pages/SearchResult/index").then((m) => ({ default: m.default }))
);
export const Groups = lazy(() =>
  import("../components/MainContent/pages/Groups").then((m) => ({ default: m.default }))
);
export const CaseGroupDetail = lazy(() =>
  import("../components/MainContent/pages/Groups/CaseGroupDetail").then((m) => ({
    default: m.default,
  }))
);
export const ClientGroupDetail = lazy(() =>
  import("../components/MainContent/pages/Groups/ClientGroupDetail").then((m) => ({
    default: m.default,
  }))
);
